document.addEventListener("DOMContentLoaded", () => {
  $('[data-toggle="tooltip"]').tooltip();
});
